export default async (endpoint, values) => {
  const response = await fetch(endpoint, {
    method: 'POST',
    body: JSON.stringify(values),
  })

  if (!response.ok) {
    throw new Error('Fetch error:', response.statusText)
  }

  try {
    const json = await response.json()
    return json
  } catch (e) {
    console.error('Error parsing JSON response', e)
  }

  return
}

export const get = async (endpoint, values) => {
  const response = await fetch(endpoint, {
    method: 'GET',
  })

  if (!response.ok) {
    throw new Error('Fetch error:', response.statusText)
  }

  try {
    const json = await response.json()
    return json
  } catch (e) {
    console.error('Error parsing JSON response', e)
  }

  return
}
